import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import React from 'react';

import { chartTypes } from './includes/chartTypes';
import { Styles } from './includes/styles';

/**
 * Chart
 *
 * A chart is a visual representation of data, often utilizing graphical elements such as lines, bars, or symbols to
 * convey information and patterns.
 *
 * @param data
 * @param dataSets
 * @param isLogarithmicScale
 * @param labels
 * @param legendLimit
 * @param maxHeight
 * @param minHeight
 * @param showLegend
 * @param tableConfiguration
 * @param tooltips
 * @param type
 * @returns {Element}
 * @constructor
 */
export function Chart({
  data = [],
  dataSets = [],
  isLogarithmicScale = false,
  labels = [],
  legendLimit = 10,
  maxHeight = '',
  minHeight = '',
  showLegend = true,
  tableConfiguration = {},
  tooltips = [],
  type = '',
}) {
  const ChartComponent = chartTypes?.[type]?.component;

  return (
    <ErrorHandler location="src/shared/ui/components/Chart/Chart.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        {!isEmpty(maxHeight) && <style>{`.chartStyles { max-height: ${maxHeight}}`}</style>}
        {!isEmpty(minHeight) && <style>{`.chartStyles { min-height: ${minHeight}}`}</style>}
        <Styles className="chartStyles">
          <Grid>
            {isEmpty(data) && isEmpty(dataSets) && isEmpty(labels) ? (
              <Grid.Col span={{ lg: '100%', md: '100%', sm: '100%', xs: '100%' }}>
                <Alert title="No data available" variant="info" />
              </Grid.Col>
            ) : (
              <Grid.Col span={{ lg: '100%', md: '100%', sm: '100%', xs: '100%' }}>
                <ChartComponent
                  data={data}
                  dataSets={dataSets}
                  isLogarithmicScale={isLogarithmicScale}
                  labels={labels}
                  legendLimit={legendLimit}
                  showLegend={showLegend}
                  tableConfiguration={tableConfiguration}
                  tooltips={tooltips}
                />
              </Grid.Col>
            )}
          </Grid>
        </Styles>
      </motion.div>
    </ErrorHandler>
  );
}
